/* global translations */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

class VerificationBenefits extends Component {
  state = {
    extended: false,
  };

  toggleExtended = (e) => {
    const { extended } = this.state;
    this.setState({ extended: !extended });

    e.currentTarget.blur();
  };

  render() {
    const { extended } = this.state;

    const { verificationRestrictions, messagesCharacterLimit } = this.props;

    const verificationFeatures = () => {
      if (!verificationRestrictions) {
        return (null);
      }

      const features = [
        {
          id: 'view_other_user_photos',
          icon: 'icon-popup_icon_4',
          text: 'txt: skatīt citu lietotāju bildes',
        },
        {
          id: 'participate_in_discussions',
          icon: 'icon-popup_icon_3',
          text: 'txt: rakstīt tērzētavā',
        },
      ];

      if (messagesCharacterLimit) {
        features.push({
          id: 'send_messages',
          icon: 'icon-popup_icon_1',
          text: 'txt: rakstīt neierobežota garuma vēstules',
        });
      }

      return (
        <div className="verification-benefits-features mtm">
          <div className="twb">
            {get(translations, 'txt: Verificēts profils ļauj pilnvērtīgi izmantot portālā pieejamās funkcijas:', '')}
          </div>
          <div>
            {features.map((feature) => (
              <div key={feature.id}>
                <span className="mrs">
                  <ImageSvg svg={feature.icon} />
                </span>
                {get(translations, feature.text, feature.text)}
              </div>
            ))}
          </div>
        </div>
      );
    };

    return (
      <div className="verification-benefits mtm">
        <div
          role="button"
          onClick={this.toggleExtended}
          onKeyDown={this.toggleExtended}
          tabIndex="0"
          className="btn btn--c btn--block btn--iconLeft btn--small verification-benefits-title"
        >
          <span>{get(translations, 'txt: Ko man dod verificēts profils', '')}</span>
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg={extended ? 'icon-arrowup' : 'icon-arrowdown'} />
              </span>
            </span>
          </span>
        </div>
        {extended && (
          <div className="verification-benefits-content tss ptm plm">
            {get(translations, 'txt: Jo sakārtotāks Tavs profils, jo ātrāk Tevi pamanīs. Profila verificēšana ir vēl viens veids, kā to izdarīt.', '')}
            {verificationFeatures()}
          </div>
        )}
      </div>
    );
  }
}

VerificationBenefits.propTypes = {
  verificationRestrictions: PropTypes.bool,
  messagesCharacterLimit: PropTypes.number,
};

VerificationBenefits.defaultProps = {
  verificationRestrictions: false,
  messagesCharacterLimit: null,
};

export default VerificationBenefits;
